import { Paper, Stack, Typography, CircularProgress, Alert, Button, Box } from '@mui/material';
import { useSalesComparison } from './useSalesComparison';
import { SalesComparisonControls } from './SalesComparisonControls';
import { SalesComparisonTable } from './SalesComparisonTable';

// Container for the store sales comparison report: owns layout, wires the data hook to the controls and
// the table. The report itself is computed by the RMS2 backend; this is a thin renderer.
export function SalesComparisonView() {
    const { period, isCurrent, receiptMode, setReceiptMode, data, loading, error, exportToExcel } = useSalesComparison();

    return (
        <Paper variant="outlined" sx={{ m: 2, p: 2 }}>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                <Typography variant="h6" sx={{ color: '#4c1d95' }}>Försäljning — Jämförelserapport</Typography>
                {data && (
                    <Typography variant="body2" color="text.secondary">
                        {data.label} · {data.currentYear} vs {data.previousYear}
                        {!data.isComplete && ` · dag 1–${data.daysElapsed} av ${data.daysTotal}`}
                    </Typography>
                )}
                {loading && <CircularProgress size={18} />}
                <Box sx={{ flexGrow: 1 }} />
                {data && (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={exportToExcel}
                        title="Exportera rapporten till Excel"
                        sx={{ bgcolor: '#4c1d95', color: '#fff', '&:hover': { bgcolor: '#3b1577' } }}
                    >
                        📥 Exportera XLSX
                    </Button>
                )}
            </Stack>

            <SalesComparisonControls
                period={period}
                current={isCurrent}
                receiptMode={receiptMode}
                onReceiptMode={setReceiptMode}
            />

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {data && !error && <SalesComparisonTable data={data} />}
        </Paper>
    );
}
